<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col>
          <h4 class="brand">
            Corporativo Alinov
          </h4>
          <span>
            © 2019, por Corporativo Alinov
          </span>
        </b-col>
        <b-col class="nav-col">
          <b-nav>
            <b-nav-item>
              <router-link to="/">Inicio</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/nosotros">Nosotros</router-link>
            </b-nav-item>
            <b-nav-item-dropdown text="Soluciones" right>
              <!--<b-dropdown-item>
                <router-link to="/jarabes">Jarabes</router-link>
              </b-dropdown-item>-->
              <b-dropdown-item>
                <router-link to="/agrícola">Agricola</router-link>
              </b-dropdown-item>
              <!--<b-dropdown-item>
                <router-link to="/agroinsumos">Kolectiva</router-link>
              </b-dropdown-item>-->
              <b-dropdown-item>
                <router-link to="/nutrición">Nutrición animal</router-link>
              </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item>
              <router-link to="/kolectiva">KOLECTIVA</router-link>
            </b-nav-item>
            <b-nav-item>
              <router-link to="/contacto">Contacto</router-link>
            </b-nav-item>
          </b-nav>
          <b-nav class="social-media">
            <b-nav-item target="_blank" href="https://www.facebook.com/corporativoalinov">
              <i class="fab fa-facebook-square"></i>
            </b-nav-item>
            <b-nav-item target="_blank" href="https://www.instagram.com/corporativoalinov">
              <i class="fab fa-instagram"></i>
            </b-nav-item>
          </b-nav>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentRoute() {
        return this.$route.name;
    }
  }
};
</script>

<style lang="scss">

.dropdown-menu {
  border-radius: 0;

  .dropdown-item {

    &:focus {
      background-color: #FFFFFF;
    }

    a {
      color: #464242;
      font-size: 13px;
    }

    a:focus, a:hover {
      text-decoration: none;
      color: #007CC2;
    }
  }
}

.footer {
  padding: 2rem 0;
  color: #FFFFFF;
  background-color: #007CC2;
  font-size: 13px;

  .brand {
    margin-bottom: 1rem;
  }

  .nav-link {
    color: #FFFFFF;

    a, a:hover, a:focus {
      color: #FFFFFF;
    }
  }

  .social-media {
    font-size: 16px;
  }
}
</style>

